module.exports = __webpack_public_path__ + "caa3adb752df006e5d66616fef06ebb7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-32.png
// module id = 1803
// module chunks = 0